var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesignStamp2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 156,
    viewBox: "0 0 155 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xA1\x9C\xEA\xB3\xA0_\xEB\x84\xA3\xEC\x9C\xBC\xEC\x8B\xA4 \xEC\x98\x81\xEC\x97\xAD"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1932_3229)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.17749,
    y: 0.401367,
    width: 154.609,
    height: 154.609,
    rx: 77.3046,
    fill: "url(#paint0_linear_1932_3229)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 26086311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3465528",
    d: "M39.4331 22.6043C39.4331 19.4309 42.0056 16.8584 45.179 16.8584H111.257C114.43 16.8584 117.003 19.4309 117.003 22.6043V39.8421H39.4331V22.6043Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3465529",
    d: "M30.8142 51.332H128.495L111.648 155.218C111.423 156.609 110.222 157.631 108.812 157.631H50.4966C49.0874 157.631 47.8862 156.609 47.6606 155.218L30.8142 51.332Z",
    fill: "#FFE9C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3465530",
    d: "M28.5024 80.5384C28.2087 78.7864 29.5594 77.1904 31.3359 77.1904H127.973C129.749 77.1904 131.1 78.7864 130.806 80.5384L122.137 132.252C121.905 133.636 120.707 134.65 119.303 134.65H40.0054C38.602 134.65 37.404 133.636 37.172 132.252L28.5024 80.5384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3465531",
    d: "M27.1409 36.0239C27.6027 33.2533 29.9998 31.2227 32.8087 31.2227H123.627C126.436 31.2227 128.833 33.2533 129.295 36.0239L131.368 48.4604H134.241C135.827 48.4604 137.113 49.7467 137.113 51.3334V54.2063H19.3223V51.3334C19.3223 49.7467 20.6085 48.4604 22.1952 48.4604H25.0682L27.1409 36.0239Z",
    fill: "url(#paint1_linear_1932_3229)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1940",
    d: "M131.368 48.4604H25.0684L27.9413 31.2227H128.495L131.368 48.4604Z",
    fill: "url(#paint2_linear_1932_3229)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "COFFEE HOLIC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.975 103.053C49.4479 103.053 46.8582 100.607 46.8582 97.1566C46.8582 93.706 49.4479 91.2598 52.975 91.2598C55.0245 91.2598 56.6769 92.0212 57.7572 93.3982L55.7554 95.245C55.0563 94.3864 54.1984 93.9166 53.1339 93.9166C51.3068 93.9166 50.0357 95.2126 50.0357 97.1566C50.0357 99.1006 51.3068 100.397 53.1339 100.397C54.1984 100.397 55.0563 99.9268 55.7554 99.0682L57.7572 100.915C56.6769 102.292 55.0245 103.053 52.975 103.053Z",
    fill: "#535043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6944 103.053C61.1355 103.053 58.514 100.559 58.514 97.1566C58.514 93.7546 61.1355 91.2598 64.6944 91.2598C68.2533 91.2598 70.8748 93.7546 70.8748 97.1566C70.8748 100.559 68.2533 103.053 64.6944 103.053ZM64.6944 100.397C66.3785 100.397 67.6972 99.1168 67.6972 97.1566C67.6972 95.1964 66.3785 93.9166 64.6944 93.9166C63.0103 93.9166 61.6916 95.1964 61.6916 97.1566C61.6916 99.1168 63.0103 100.397 64.6944 100.397Z",
    fill: "#535043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2103 93.9166C76.6215 93.9166 75.7318 94.6132 75.7318 96.0712V96.46H80.0056V98.9386H75.7318V102.827H72.586V96.1198C72.586 93.0256 74.572 91.2598 77.972 91.2598C79.2589 91.2598 80.4346 91.519 81.2449 92.005L80.3234 94.4674C79.672 94.0786 78.8935 93.9166 78.2103 93.9166Z",
    fill: "#535043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8181 93.9166C86.2294 93.9166 85.3396 94.6132 85.3396 96.0712V96.46H89.6135V98.9386H85.3396V102.827H82.1938V96.1198C82.1938 93.0256 84.1798 91.2598 87.5798 91.2598C88.8667 91.2598 90.0424 91.519 90.8527 92.005L89.9312 94.4674C89.2798 94.0786 88.5013 93.9166 87.8181 93.9166Z",
    fill: "#535043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.601 99.6028L101.555 101.968C100.427 102.632 98.6948 103.053 96.9312 103.053C93.277 103.053 91.4022 101.612 91.4022 99.6028C91.4022 98.4202 92.0695 97.4644 93.1976 96.9784C92.3237 96.5086 91.863 95.65 91.863 94.6942C91.863 92.8798 93.5153 91.2598 97.1536 91.2598C98.6471 91.2598 100.125 91.5676 101.189 92.0374L100.331 94.435C99.2826 93.9652 98.2817 93.7708 97.2807 93.7708C95.7237 93.7708 95.0406 94.2244 95.0406 94.9048C95.0406 95.5204 95.4536 95.8768 96.4228 95.8768H99.5686V98.323H96.2163C95.1359 98.323 94.5798 98.6956 94.5798 99.376C94.5798 100.073 95.2948 100.542 97.0583 100.542C98.2499 100.542 99.648 100.186 100.601 99.6028Z",
    fill: "#535043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.497 99.6028L112.45 101.968C111.322 102.632 109.59 103.053 107.827 103.053C104.173 103.053 102.298 101.612 102.298 99.6028C102.298 98.4202 102.965 97.4644 104.093 96.9784C103.219 96.5086 102.759 95.65 102.759 94.6942C102.759 92.8798 104.411 91.2598 108.049 91.2598C109.543 91.2598 111.02 91.5676 112.085 92.0374L111.227 94.435C110.178 93.9652 109.177 93.7708 108.176 93.7708C106.619 93.7708 105.936 94.2244 105.936 94.9048C105.936 95.5204 106.349 95.8768 107.318 95.8768H110.464V98.323H107.112C106.031 98.323 105.475 98.6956 105.475 99.376C105.475 100.073 106.19 100.542 107.954 100.542C109.146 100.542 110.544 100.186 111.497 99.6028Z",
    fill: "#535043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3678 108.798H63.5136V120.138H60.3678V115.716H56.0781V120.138H52.9323V108.798H56.0781V113.059H60.3678V108.798Z",
    fill: "#535043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4999 120.365C67.941 120.365 65.3195 117.87 65.3195 114.468C65.3195 111.066 67.941 108.571 71.4999 108.571C75.0588 108.571 77.6803 111.066 77.6803 114.468C77.6803 117.87 75.0588 120.365 71.4999 120.365ZM71.4999 117.708C73.184 117.708 74.5027 116.429 74.5027 114.468C74.5027 112.508 73.184 111.228 71.4999 111.228C69.8158 111.228 68.4971 112.508 68.4971 114.468C68.4971 116.429 69.8158 117.708 71.4999 117.708Z",
    fill: "#535043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4868 120.138V108.798H82.6326V117.595H87.9392V120.138H79.4868Z",
    fill: "#535043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5709 111.277H93.7756V117.66H95.5709V120.138H88.8186V117.66H90.6298V111.277H88.8186V108.798H95.5709V111.277Z",
    fill: "#535043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.898 120.365C99.3704 120.365 96.7807 117.919 96.7807 114.468C96.7807 111.018 99.3704 108.571 102.898 108.571C104.947 108.571 106.599 109.333 107.68 110.71L105.678 112.557C104.979 111.698 104.121 111.228 103.056 111.228C101.229 111.228 99.9583 112.524 99.9583 114.468C99.9583 116.412 101.229 117.708 103.056 117.708C104.121 117.708 104.979 117.239 105.678 116.38L107.68 118.227C106.599 119.604 104.947 120.365 102.898 120.365Z",
    fill: "#535043"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1932_3229",
    x1: 77.4821,
    y1: -10.1039,
    x2: 77.4821,
    y2: 155.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79531A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1932_3229",
    x1: 78.2179,
    y1: 31.2227,
    x2: 78.2179,
    y2: 47.0239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCDCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1932_3229",
    x1: 78.2181,
    y1: 49.8969,
    x2: 78.2181,
    y2: 38.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1932_3229"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.17749,
    y: 0.401367,
    width: 154.609,
    height: 154.609,
    rx: 77.3046,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignStamp2);
export default __webpack_public_path__ + "static/media/DesignStamp2.28216d5184dc2a588ea0dc3193bd8f15.svg";
export { ForwardRef as ReactComponent };